import React from 'react';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';
import { AddCustomLinkForm } from '@mnz/element';
import { CustomLinkValues } from '@mnz/element/build/basic/custom-link/EditCustomLink';

interface AddOrderLinkModalProps extends DialogProps {
    onSubmitCustomLink: (values: CustomLinkValues) => void;
    setOpenModalAddCustomLink: (open: boolean) => void;
}
const AddCustomLinkModal: React.FC<AddOrderLinkModalProps> = ({
    onSubmitCustomLink,
    setOpenModalAddCustomLink,
    ...props
}) => {
    return (
        <Dialog {...props}>
            <div className="mt-20 px-24 pb-50">
                <AddCustomLinkForm
                    onSubmitCustomLink={onSubmitCustomLink}
                    onCancel={() => setOpenModalAddCustomLink(false)}
                />
            </div>
        </Dialog>
    );
};

export default AddCustomLinkModal;
